import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Primitives";
import { useNavigate } from "react-router-dom";

export default function StudentTests() {
  const [tests, setTests] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/tests/available").then(r => setTests(r.data)); }, []);

  return (
    <div>
      <PageHeader eyebrow="Assessments" title="Available tests" subtitle="MCQ assessments visible once published by your faculty." />
      {tests.length === 0 ? <EmptyState title="Nothing scheduled right now" /> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {tests.map(t => (
            <div key={t.id} className="card-academic p-6">
              <div className="overline">{t.class_group} · {t.duration_minutes} min · {t.total_marks} marks</div>
              <h4 className="font-serif text-2xl text-forest mb-2">{t.title}</h4>
              {t.scheduled_at && (
                <p className="text-xs text-mossy font-mono mb-3">
                  Opens {new Date(t.scheduled_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}
                  {t.scheduled_until && (
                    <>
                      {" "}
                      · Complete by {new Date(t.scheduled_until).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}
                    </>
                  )}
                </p>
              )}
              {t.attempted
                ? <div className="overline text-forest">Already attempted</div>
                : <button onClick={() => nav(`/student/tests/${t.id}`)} className="btn-primary w-full" data-testid={`start-${t.id}`}>Begin test</button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
